module.exports = __webpack_public_path__ + "static/face-5-bb6cbb7ec773bcd05dfd07c4c33783aa.png";